import { useState } from "react";

import Chip from "../Chip/Chip";
import NameEdit from "../NameEdit/NameEdit";
import MoreActions from "../ConditionsTree/ConditionFields/MoreActions";
import FieldFunctionBox from "./FieldFunctionBox";

export default function FieldChip({
  ruleId,
  entityField,
  canEdit = true,
  drag = false,
  rightSlot,
  onDelete,
  showOptions = true,
  dragRef,
  dragHandleProps,
  dragStyle,
}) {
  const [editing, setEditing] = useState(false);
  const savedFunction = entityField?.entityFieldFunction;
  const name = entityField?.name || entityField?.field?.name;

  const options =
    showOptions && canEdit ? (
      <MoreActions
        ruleId={ruleId}
        id={entityField?.id}
        setNameEditMode={setEditing}
        showFunctionsPopover={!savedFunction}
        showChangeAlias
        showTypeSwitch={false}
      />
    ) : null;

  const chip = (
    <Chip
      name={name}
      canEdit={canEdit}
      drag={drag}
      rightSlot={rightSlot}
      optionsSlot={options}
      onDelete={onDelete}
      fullWidth={!!savedFunction}
    />
  );

  let element;
  if (editing) {
    element = (
      <NameEdit
        ruleId={ruleId}
        id={entityField?.id}
        defaultValue={name}
        onDone={() => setEditing(false)}
      />
    );
  } else if (savedFunction) {
    element = (
      <FieldFunctionBox
        ruleId={ruleId}
        functionData={savedFunction}
        content={chip}
        canEdit={canEdit}
      />
    );
  } else {
    element = chip;
  }

  return (
    <div
      ref={dragRef}
      style={dragStyle}
      {...(canEdit && !editing && dragHandleProps ? dragHandleProps : {})}
    >
      {element}
    </div>
  );
}
